<template>
    <div id="newsheader">
        <div id="header1">
            <img src="/images/web_img/TOG_Logo_500X70_3.jpg" alt="">
            <div>
                {{now1}}
            </div>
            <div class="topbar">
                <router-link to="/">Home</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import clock from "@/mixins/clock";

    export default {
        name:'newsheader',
        mixins: [clock],
    }
</script>

<style lang="scss" scoped>
    #newsheader{
        width: 1000px;
        margin: 0 auto;
        
        #header1{
            width: 1000px;

            background-color: white;

            div{
                margin: 20px auto 0 auto;
                padding-bottom: 20px;
            }
            .topbar{
                width: 1000px;
                height: 43px;

                background-color: #12278D;

                margin:0 auto 0 auto;
                padding: 0;

                a{
                    width: 120px;
                    height: 33px;
                    
                    color: white;

                    display: block;

                    float: left;
                    padding-top: 10px;

                    &:hover{
                        text-decoration:none;
                        cursor: pointer;
                    }
                }
            }
        }
    }

</style>


